import { push } from '@lagunovsky/redux-react-router'
import { PATH_NAME } from 'app/constants'
import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from 'components/Typography/Typography'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import './../Modal.scss'

export default function ModalWarning({ warningType, onContinue, onBack }) {
    const intl = useIntl()
    const dispatch = useDispatch()
    const handleBack = () => {
        if (warningType === 'modalBasketChange') {
            dispatch(push(PATH_NAME.BUY_TICKET_VOUCHER))
            return
        }
        dispatch(push(PATH_NAME.YOUR_ORDER))
    }
    if (!warningType) {
        return
    }
    return (
        <div className="modal-message">
            <div className="window">
                <div className="title-section">
                    <Typography variant={'h1'}>{intl.formatMessage({ id: `modals.${warningType}.title` })}</Typography>
                </div>
                <Typography variant={'p'}>{intl.formatMessage({ id: `modals.${warningType}.text` })}</Typography>
                <div className="buttons-section">
                    <ButtonCinestar onClick={() => handleBack()} variant={'primary-v1'}>
                        {intl.formatMessage({ id: `modals.${warningType}.backBtn` })}
                    </ButtonCinestar>
                    <ButtonCinestar onClick={onContinue} variant={'primary-v1'}>
                        {intl.formatMessage({ id: `modals.${warningType}.continueBtn` })}
                    </ButtonCinestar>
                </div>
            </div>
        </div>
    )
}
